













































































































































  import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
  import Util from '../../lib/util'
  import AbpBase from '../../lib/abpbase'
  import AnnualManagementPlan from '../../store/entities/annualmanagementplan'
  import UtilUrl from '../../lib/url'
  import appconst from '../../lib/appconst'

  @Component
  export default class CreateAnnualManagementPlan extends AbpBase{


      
      @Prop({type:Boolean,default:false}) value:boolean;
  
      user:AnnualManagementPlan=new AnnualManagementPlan();
      
      get wastelist(){
        console.log(this.$store.state.annualmanagementplan.wastelist)
          return this.$store.state.annualmanagementplan.wastelist;
      }
      set wastelist(val){
        console.log(val)
         this.$store.commit('annualmanagementplan/change_hd',val);
      }   
      
       
     get produceDataitems(){
         return this.$store.state.annualmanagementplan.produceDataitems;

     }
      addProduceData(){
       
      this.$store.state.annualmanagementplan.produceDataitems.push({
        hazardouswaste:"",thisyearweight:0.01,lastyearweight:0.01
      })  
    }
    deleteRow(index){

       this.$store.state.annualmanagementplan.produceDataitems.splice(index,1);
    }
    change_hd(val){
       
             this.wastelist=[];
            var lst=this.$store.state.annualmanagementplan.hazardouswasteinformationlist;
            lst.forEach(x=>{
                if(val==x.id){
                  this.wastelist=x.wastelist;
                 // console.log(x.wastelist)
                }

            })
             
    }
      
    
 
     save(){
        
        //console.log(this.$store.state.annualmanagementplan.produceDataitems)
      
    
          (this.$refs.userForm as any).validate(async (valid:boolean)=>{
                    this.user.annualManagementPlanDetails=this.$store.state.annualmanagementplan.produceDataitems;
                    var ampdnum=0;
                    this.$store.state.annualmanagementplan.produceDataitems.forEach(item=>{
                           if(item.hazardouswaste.length>0&&item.thisyearweight>0&&item.lastyearweight>0){
                              ampdnum++;
                           } 
                      })
                        if(ampdnum==0){
                          valid=false;
                           this.$Message.error('危险废物产生情况至少填写一栏');
                        }  

              if(valid){
                 
                  await this.$store.dispatch({
                      type:'annualmanagementplan/create',
                      data:this.user
                  });
                  (this.$refs.userForm as any).resetFields();
                  this.$emit('save-success');
                  this.$emit('input',false);
              }
          })
      }
      cancel(){
          (this.$refs.userForm as any).resetFields();
          this.$emit('input',false);
      }
       
      created() {
        
      
      }


      userRule={
         



          enterpriseinformationid:[{type:'number', required: true,message:'请选择所属单位',}],
          customizeddate:[{type:'date', required: true,message:'请选择定制日期',trigger: 'change'}],
          startdate:[{type:'date',required: true,message:'请选择开始日期',trigger: 'blur'}],
          enddate:[{type:'date',required: true,message:'请选择结束',trigger: 'blur'}],
        


      }

      

       visibleChange(value:boolean){
          if(!value){
              this.$emit('input',value);
              
          }
      }
}
   
      
          
